import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';

// for parkplus store
export const checkStoreLocationServiceable = async ({ pincode }: { pincode: string }) => {
  const endPoint = `${apiConfig(
    'fulfillmentOriginal',
  )}/delivery/new-expected-delivery?delivery_postcode=${pincode}`;
  const { response, error }: any = await getMethod({ endPoint });

  if (response) {
    return { isServiceable: response?.data?.is_serviceable };
  } else if (error) {
    return { error };
  }
  return { isServiceable: false };
};

export const checkCarWaxServiceable = async ({ pincode }: { pincode: string }) => {
  const endPoint = `${apiConfig(
    'carWashOriginal',
    'v2',
  )}/b2c/carwax/service-area-status?pincode=${pincode}`;
  const { response, error }: any = await getMethod({ endPoint });

  if (response) {
    if (!response?.data?.is_serviceable) {
      // trackPageLoad('Select address', 'Not serviceable ', pincode);
    }
    return { isServiceable: response?.data?.is_serviceable };
  } else if (error) {
    return { error };
  }
  return { isServiceable: false };
};

// for carwash project serviceable
export const validateCarwashProject = async ({ lat, lng }) => {
  const { response, error }: any = await getMethod({
    endPoint: `${apiConfig(
      'carWash',
      'v2',
    )}/carwash-service-available?latitude=${lat}&longitude=${lng}`,
  });
  if (response?.data?.project_id) {
    return { isServiceable: true };
  }
  if (error) {
    return { error };
  }

  return { isServiceable: false };
};

export const checkCarCareServiceability = async ({
  lat,
  lng,
}: {
  lat: string | number;
  lng: string | number;
}) => {
  const { response, error }: any = await getMethod({
    endPoint: `${apiConfig('carCare')}/v1/car-care/serviceability`,
    params: {
      latitude: lat,
      longitude: lng,
    },
  });

  if (response?.data) {
    return {
      isServiceable: !!response.data.serviceable,
      clusterId: response.data.cluster_id,
    };
  }

  if (error) {
    return { error };
  }

  return { isServiceable: false };
};
